<template>
  <div>
    <v-row class="ma-0">
      <v-col class="pa-0" cols="8">
        <h2 class="heading">Diagnostics Tool</h2>
      </v-col>
    </v-row>
    Analyze the historical performance of your model.
    <DiagnosticsModal
      :model="model"
      :models="models"
      :current-round-info="currentRoundInfo"
    >
      <button
        class="numerai-button mt-3
                        full-width"
        @click="() => false"
      >
        Diagnostics Tool
      </button>
    </DiagnosticsModal>
  </div>
</template>

<script>
import DiagnosticsModal from './DiagnosticsModal.vue'

export default {
  components: {
    DiagnosticsModal,
  },
  props: {
    currentRoundInfo: { type: Object, default: () => null },
    model: { type: Object, default: () => null },
    models: { type: Array, default: null },
  },
  data: function() {
    return {
      today: new Date().getDay(),
      timeUntilNextRoundMs: 0,
    }
  },
}
</script>

<style scoped>
.text {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  margin-bottom: 12px;
}
hr.thick {
  border: none;
  border-top: 3px solid var(--divider-color);
  height: 15px;
}
.label {
  font-size: 10px;
  opacity: 0.5;
}
.heading {
  text-transform: none;
  font-family: var(--ui-font);
  font-weight: 600;
}
.tip {
  padding: 0px;
  margin-top: 5px;
}

.full-width {
  width: 100%;
}
.numerai_info_bubble a {
  color: var(--color-primary);
}
.filename {
  display: block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  margin-bottom: 0.4em;
  padding: 0.2em 0;
}
</style>
